/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIpsec = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 6c.913 0 1.963.971 1.963 2.59v1.871h-3.926V8.59C10.037 6.97 11.087 6 12 6zm3.963 4.462V8.59C15.963 6.243 14.36 4 12 4 9.64 4 8.037 6.243 8.037 8.59v1.872H6V20h12v-9.539zm-7.963 2h8V18H8zm13.277.83L23.986 16l-2.707 2.707-1.415-1.414L21.156 16l-1.293-1.293zm-18.554 0 1.414 1.415L2.844 16l1.293 1.293-1.414 1.414L.016 16z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIpsec as Ipsec };
